var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.38,
    height: 24.357,
    viewBox: "0 0 24.38 24.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2659",
    "data-name": "Group 2659",
    transform: "translate(1850 -509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    "data-name": "Path 8896",
    d: "M21.5,27H6.5A3.5,3.5,0,0,1,3,23.5V8.5A3.5,3.5,0,0,1,6.5,5H13a1,1,0,0,1,0,2H6.5A1.5,1.5,0,0,0,5,8.5v15A1.5,1.5,0,0,0,6.5,25h15A1.5,1.5,0,0,0,23,23.5V17a1,1,0,0,1,2,0v6.5A3.5,3.5,0,0,1,21.5,27Z",
    transform: "translate(-1853 506.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8897",
    "data-name": "Path 8897",
    d: "M25.42,10l1.23-1.23a2.51,2.51,0,0,0,0-3.54L24.77,3.35a2.57,2.57,0,0,0-3.54,0L20,4.58Z",
    transform: "translate(-1853 506.357)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8898",
    "data-name": "Path 8898",
    d: "M18.58,6l-6.29,6.29a1,1,0,0,0-.27.51l-1,5A.993.993,0,0,0,12,19h.2l5-1a1,1,0,0,0,.51-.27L24,11.42Z",
    transform: "translate(-1853 506.357)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEditIcon);
export default __webpack_public_path__ + "static/media/blue_edit_icon.d90f4e958d869387427ceced4b9e524c.svg";
export { ForwardRef as ReactComponent };